
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const NewPatchPolicyPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to patching page since we now use a dialog
    navigate("/patching");
  }, [navigate]);

  return null;
};

export default NewPatchPolicyPage;
